import { css, cx } from '@emotion/css';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { Layout } from '../../shared/components/layout/Layout';
import { h1Style } from '../../shared/styles/text';
import {
  authHeaderStyle,
  authSubtitleStyle,
} from '../../shared/styles/auth-layout';
import {
  Button,
  ButtonSizeEnum,
  ButtonVariantEnum,
} from '../../shared/components/Button';
import { ChevronLeft } from '../../shared/assets/icons';
import { useNavigator } from '../../routing/navigator';

export const ForgotPasswordPage = (): JSX.Element => {
  const navigator = useNavigator();
  return (
    <Layout.Content className={pageStyle}>
      <Button
        startIcon={<ChevronLeft />}
        variant={ButtonVariantEnum.TEXT}
        size={ButtonSizeEnum.LARGE}
        text={`back`}
        className={backButtonStyle}
        onClick={navigator.toPrevious}
      />
      <h1 className={cx(h1Style, authHeaderStyle)}>Forgot password?</h1>
      <p className={authSubtitleStyle}>
        Enter the email you signed up with and we will send you a link to set a
        new password.
      </p>
      <ForgotPasswordForm />
    </Layout.Content>
  );
};

const pageStyle = css`
  padding-top: 0.625rem;
`;

const backButtonStyle = css`
  padding-top: 0;
  margin-bottom: 1.5rem;
`;
